import { forwardRef } from 'react'
import { TextArea } from '@carbon/react'
import type { TextAreaProps } from '@carbon/react'
import type { FormTextareaProps } from './types'
import { narrowToStringOrNumber } from './utils'
import { FormFieldLabel } from './FormFieldLabel'
import styles from './FormField.module.scss'

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  (
    {
      label,
      error,
      required,
      hint,
      className = '',
      defaultValue,
      value,
      onClick,
      ...props
    },
    ref
  ) => {
    const fieldId = props.id || props.name || `textarea-${Math.random()}`

    const textAreaProps: TextAreaProps = {
      ...props,
      defaultValue: narrowToStringOrNumber(defaultValue),
      value: narrowToStringOrNumber(value),
      id: fieldId,
      labelText: <FormFieldLabel label={label} required={required} />,
      invalid: !!error,
      invalidText: error,
      helperText: hint && !error ? hint : undefined,
      ...(onClick && { onClick: onClick as TextAreaProps['onClick'] }),
    }

    return (
      <div className={`${styles.wrapper} ${className}`}>
        <div className={styles.fieldWrapper}>
          <TextArea ref={ref} {...textAreaProps} />
        </div>
      </div>
    )
  }
)

FormTextarea.displayName = 'FormTextarea'
